import { Div, Text } from "@hopper-ui/components";

interface Props {
    title: string;
}

export const ChannelTitle = ({ title }: Props) => {
    return (
        <Div
            backgroundColor="neutral-weakest"
            borderBottom="neutral-weakest"
            paddingX="inset-md"
            paddingY="inset-sm"
        >
            <Text
                size="xs"
                fontFamily="overline"
                textTransform="uppercase"
                color="neutral-weak"
            >
                {title}
            </Text>
        </Div>
    );
};
